import type {
  UpdateUserPayloadInput,
  UserChangeStatePayload,
  UserResendInvitePayload,
} from '@domain/schemas/payload.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { GetUserResponse } from '@responses/users';
import axios from 'axios';

type Data = UpdateUserPayloadInput | UserResendInvitePayload | UserChangeStatePayload;

export const updateUser = async (id: string, data: Data): Promise<GetUserResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: `users/${id}`,
    data,
  });

  const response = await axios(networkPayload);
  return response.data;
};
